// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3nWpr","type":"styles_type__rF9N7","choices":"styles_choices__3nS9x"};